import React from "react";

import "./Footer.css";

export const Footer = () => (
    <a className="footer" href="http://pavelpo.cz/">
        Pavel Pospíšil 2017–{(new Date()).getFullYear()}
    </a>
);
